export default {
  titles: {
    encoding: '编码',
    inbound: '入站',
    user_info: '用户信息',
    settings: '设置',
    reset_daily_items: '重置每日物品？',
    last_parcels: '最后一个包裹',
    select_item: '选择项目',
    select_workstation: '选择工作站',
    select_language: '选择语言',
    support: '支持',
    select_printer: '选择打印机',
    shipment_to_confirm: '发货确认',
    sorting_details: '通风细节',
    inventories: '库存',
    pin_modal: '输入针对力关联',
    shipments: '货物',
    report_problem: '报告问题',
    parcels: '包裹',
    outbound_bthp: '出站BTHP证书'
  },
  simple_parcel_list: {
    to_read: '阅读',
    ok: '好的',
    force: '力量',
    force_parcel: '力包裹 {{code}}',
    force_parcel_desc: '插入用户别针强制包裹',
    forced: '强迫',
    unexpected: '意外',
    remove: '消除',
    invalid_pin: '用户别针无效',
    loading: '加载包裹列表'
  },
  create_parcel_gate: {
    //moncler
    width: '宽度',
    height: '高度',
    depth: '深度',
    tare: '皮重',
    description: '描述'
  },
  fields: {
    current_location: '当前位置',
    identified_item: '确定的项目',
    ignored_items: '忽略项目',
    ignored_with_reason_items: '因理性项目而忽略',
    error_items: '错误项目',
    warning_items: '警告项目',
    umg: 'UMG',
    custom_class: '自定义类',
    product_code: '产品代码',
    as400username: '用户名AS400',
    item_components: '成分',
    mission: '使命',
    mission_type: '任务类型',
    supplier: '供应商',
    physical_storage: '物理存储',
    season: '季节',
    ddt: 'DDT',
    notification: '通知',
    ddt_date: 'DDT日期',
    notification_date: '通知日期',
    product_category: '产品类别',
    status: '地位',
    date: '日期',
    creation_date: '创建日期'
  },
  misc: {
    select_an_option: '选择一个选项...',
    not_set: '未设置',
    current_value: '当前值',
    not_associated: '无关',
    replaced: '更换',
    production_order_info: '生产订单信息',
    reel_info: '卷轴信息',
    reel_code: '卷轴代码',
    assigned_supplier: '分配的供应商',
    type: '类型',
    identifier_info: '标识符信息',
    identifier_events: '标识符事件',
    or: '或者',
    select_place: 'Ciao {{user}},选择您的原产地继续',
    back: '后退',
    refresh: '刷新',
    reload: '重新加载',
    save: '节省',
    confirm: '确认',
    confirm_auto: '自动企业',
    update_and_confirm: '更新并确认',
    update: '更新',
    no_carton_found: '找不到纸箱',
    confirm_continue: '确认并继续',
    cancel: '取消',
    close: '关闭',
    user: '用户',
    workstation: '工作站',
    username: '用户名',
    name: '姓名',
    password: '密码',
    login: '登录',
    encoding: '编码',
    code: '代码',
    ean_code: 'EAN代码',
    certilogo: 'certilogo',
    enter_the_necessary_fields: '输入必要的字段开始操作',
    associated_items: '关联的项目',
    associate: '联系',
    associated: '联系',
    verify: '核实',
    verify_association: '核实',
    reading: '阅读',
    processing: '加工',
    association: '协会',
    associations: '协会',
    waiting: '等待',
    writing: '写作',
    writing_progress: '写作正在进行...',
    partial_confirm: '部分确认',
    retry: '重试',
    writing_association: '写作与协会',
    confirmed: '确认的',
    unable_to_write: '无法编写EPC标签:  {{code}} 对于产品:  {{productCode}}',
    unable_to_get_next_epc: '无法获得下一个EPC:  {{productCode}}',
    unable_to_connect_to_workstation: '无法连接到工作站',
    tag_info: '标签信息',
    inbound: '入站',
    outbound: '出站',
    stop: '停止',
    start: '开始',
    pause: '暂停',
    clear: '清除',
    tag_encoded_today: '标签今天编码',
    transaction_date: '交易日期',
    select_transaction_date: '选择交易日期',
    ready_to_receive: '准备接收',
    change_password: '更改密码',
    logout: '注销',
    are_you_sure_to_logout: '您真的想注销吗？',
    settings: '设置',
    roles: '角色',
    email: '电子邮件',
    place: '地方',
    items: '项目',
    description: '描述',
    color: '颜色',
    size: '尺寸',
    part: '部分',
    total_reads: '总读数',
    total_ok: '总好',
    save_to_list: '保存列表',
    destination: '目的地',
    origin: '起源',
    new_parcel: '新包裹',
    status: '地位',
    parcel: '包裹',
    read_parcel: '阅读包裹',
    parcels: '包裹',
    shipment: '运输',
    creation_date: '创建日期',
    search: '搜索',
    select_search: '搜索...',
    detail: '细节',
    quantity: '数量 （{{quantity}}）',
    only_quantity: '数量',
    style: '风格',
    material: '材料',
    shipment_code_auto: '发货代码（自动）',
    parcel_code_auto: '包裹代码（自动）',
    next: '下一个',
    parcels_to_receive: '收到的包裹',
    confirm_parcel: '确认包裹',
    image_missing: '图像缺失',
    image: '图像',
    loading: '加载中...',
    unknown_product: '未知产品',
    unknown_tag: '未知标签',
    invalid_tag: '无效标签',
    virgin_tag: '处女标签',
    tag_not_associated: '标签不关联',
    killed: '被杀',
    stock: '库存',
    valid: '有效的',
    unknown: '未知',
    actions: '动作',
    reprint: '重印',
    product: '产品',
    product_items: '产品项目',
    identifiers: '标识符',
    zone: '区',
    report_repair: '报告维修',
    reason: '原因',
    request_code_change: '请求代码更改',
    enable_workstation_emulation: '启用工作站仿真',
    enable_browser_print_emulation: '启用浏览器打印仿真',
    filter: '筛选',
    language: '语言',
    warning: '警告',
    success: '成功',
    info: '信息',
    checklist: '清单',
    optional: '选修的',
    phone: '电话',
    version: '版本',
    printer: '打印机',
    new_shipment: '新装运',
    upc: 'UPC',
    model_part_color_size: '型号 /零件 /颜色 /尺寸',
    confirm_shipment: '确认发货',
    receive: '收到',
    delete: '删除',
    delete_association: '删除',
    change: '改变',
    from: '从',
    to: '到',
    ignored: '被忽略',
    skipped: '跳过',
    ignored_with_reason: '被理性忽略',
    yes: '是的',
    no: '不',
    model: '模型',
    typology: 'Tipo',
    no_result: '没有结果',
    expected: '预期的',
    expected_plural: '预期的',
    read: '读',
    missing: '丢失的',
    unexpected: '意外',
    unexpected_parcel: '意外的包裹',
    ignored_plural: '被忽略',
    serial: '系列',
    priority: '优先事项',
    group: '团体',
    required_quantity: '需要数量',
    sorted_quantity: '通风的数量',
    missing_quantity: '缺少数量',
    barcode: '条形码',
    barcode_bc: '条形码BC',
    sorted_date: '通风日期',
    customer: '客户名称',
    list: '列表',
    list_position: '列表位置',
    select_date: '选择日期',
    item_info: '项目信息',
    item_events: '项目事件',
    operation_type: '操作类型',
    operation_place: '操作地点',
    loading_data: '请等待,数据正在加载...',
    empty_item_events: '找不到事件',
    show_more: '显示更多',
    hide_more: '隐藏更多',
    production_order: '生产订单',
    production_order_detail: '生产订单细节',
    production_order_row: '生产订单行',
    production_order_sku: '生产订单SKU',
    kill_tag: '杀死标签',
    replace_tag: '更换标签',
    replace_tag_with: '用 {{tag}}',
    item_po: '项目父订单',
    item_order: '项目订单',
    item_row: '项目行',
    pack_code: '软件包代码',
    send_reads: '发送读数',
    items_add_inventory_success: '库存中添加的项目',
    new: '新的',
    confirm_mission: '确认任务',
    confirm_mission_text: '您确定要确认任务吗？',
    parziali: '部分的',
    total_quantity: '总数',
    accepted_quantity: '接受数量',
    country_check: '国家控制',
    showcase_check: '展示控制',
    attention: '注意力',
    clear_items: '程序将删除所有读数,您想继续吗？',
    add_partial: '注意力',
    add_partial_text: '可能有必要创建质量保证任务',
    add_partial_already_text: '可能需要创建质量保证任务。UMG 已生效。是否要覆盖已读取的项目？',
    error_cq_mission: '注意,创造质量控制任务',
    warning_zone_items: 'in_another_zone',
    internal_tag: '内部标签',
    external_tag: '外部标签',
    error_tag: '错误标签',
    awaiting: '等待',
    error_logs: '错误日志',
    event_logs: '事件日志',
    box_closed: '盒子关闭',
    box_out: '卡位',
    unexpected_list: '意外的项目列表',
    pending_tags: '等待标签',
    selected_zone: '选定区域',
    pricing: '定价',
    send_to_sap: '发送到SAP',
    write_tag: '写标签',
    identifier_tag: '标识符标签',
    digit_identifier_tag: '数字标签写',
    target_epc: '目标EPC',
    retry_write_tag: '遇到写入错误。是否要再次尝试写入标签？',
    ready: '准备好',
    offline: '离线',
    shipping_date: '运输日期',
    update_only_product: '此商品已与其他产品关联。您确定要覆盖它吗？',
    export: '出口',
    select_zone: '选择区域',
    location_origin: '位置起源',
    confirm_kill_tag: '您想杀死哪些标签？',
    kill_in_progress: '杀死标签正在进行',
    confirm_replace_tag: '您想更换哪些标签？',
    replace_in_progress: '更换正在进行的标签',
    select_tag_to_kill: '选择要杀死的标签',
    disassociating_item: '分离项目',
    killing_tag: '杀人 {{type}} 带有角色标签 {{role}}',
    retry_kill_tag: '遇到了终止错误。是否要再次尝试终止该标签？',
    reading_tag: '阅读标签',
    writing_tag: '写标签',
    writing_tag_with: '写标签 {{tag}}',
    navBackWarning: '确定要返回吗？所有未保存的更改（例如读数）都将丢失。',
    sentry: {
      report_problem: '描述您遇到的问题或提出改进建议'
    },
    ready_to_read: '准备阅读',
    remove_product_readings: '删除产品读数',
    ok: '好的',
    already_in_parcel: '已经在包裹中了',
    operation_canceled_by_user: '用户取消操作',
    load_more: '加载正在进行中',
    input: '输入',
    rfid_barcodes: 'RFID条形码',
    submit: '提交',
    error: '错误',
    OK_WORKER: '好的工人',
    KO_WORKER: 'KO工人',
    OK_REPAIR: '确定维修',
    RESO_RICHIESTO_CQ: 'QC请求',
    RESO_OK: '确定返回',
    OK_VALDAGNO: '好的瓦尔达诺',
    KO_VALDAGNO: 'Ko Valdagno',
    SECOND_VALDAGNO: '第二选择',
    OK_LINING: '好的衬里',
    ok_first_inbound_status: '好的,首先入站',
    OK_RISC: '风险',
    KO_LINING: 'KO衬里',
    size_color: '尺寸/颜色',
    select_size_color: '选择大小/颜色',
    print: '打印',
    missings: '错过',
    embedded: '嵌入',
    ignoreds: '忽略',
    select_printer: '选择打印机',
    printing_started: '打印开始',
    release_reports: '发布报告',
    quality_checks: '质量检查',
    quality_check: '质量检查',
    total_mission_qty: 'QTA Totale Mission',
    inbound_read_qty: 'QTA Letta Ingresso Varco',
    checked_qty: 'QTA Controlli Effettuati',
    checked: 'Collaudati',
    returned: 'rientrati',
    damaged: 'difetti',
    qty_damaged_first_check: 'QTA difettati 1°控制',
    first_check_date: '数据1°控制',
    qty_damaged_second_check: 'QTA difettati 2°控制',
    second_check_date: '数据2°控制',
    note: '笔记',
    work_order: '工作订单',
    order_type: '订单类型',
    start_and_read: '请启动天线并放置产品',
    emulate: '仿真',
    advanced_emulation: '晚期仿真',
    emulation_history: '仿真历史',
    emulation_favorites: '最爱',
    power: '力量',
    sensitivity: '灵敏度',
    expected_quantity: '预期的',
    extra_quantity: '额外的',
    encoded_quantity: '编码',
    clear_and_restart: '清除并重新启动',
    all: '全部',
    today: '今天',
    lastweek: '上星期',
    specific: '具体的',
    apply: '申请',
    products: '产品',
    last_paired_sn: '最后一个配对的SN',
    last_confirmed_ucs: '最后一个确认的UCS'
  },
  error: {
    error: '错误',
    errors: '错误',
    forbidden: '禁止',
    not_found: '未找到',
    product_not_found: '未找到产品',
    unauthorized: '未授权',
    too_many_tags_read: '读取的标签过多（预期 {{exptected}} 个标签已读取 {{read}} 个标签）',
    too_many_checklist_types: '清单类型过多。请确保选择清单类型相同的包裹。',
    rfid_discrepancies_found: '发现 RFID 差异,请全部清除并重试或确认差异',
    certilogo_not_found: '未找到 Certilogo "{{code}}"',
    ean_not_found: '未找到 EAN "{{code}}"',
    production_order_not_found: '未找到生产订单 "{{code}}"',
    no_inbound_zones: '无入库区域',
    no_operation_config: '未找到操作配置',
    not_supported_reading_mode: '不支持读取模式',
    undefined_operation_config: '无法取消定义操作配置',
    certilogo_already_encoded: 'Certilogo "{{code}}" 已编码',
    tag_not_found: '未找到标签',
    missing_printer_id: '缺少打印机 IP',
    tag_unassociated: '标签未关联',
    tag_type_unexpected: '标签类型错误',
    tag_already_associated: '标签已关联。您必须先取消关联',
    tags_not_associated: '一个或多个标签未关联',
    tags_mismatch: '标签不匹配',
    workstation_could_not_be_started: '工作站 {{code}} 无法启动',
    antenna_was_started: '天线 {{code}} 已启动',
    antenna_was_not_started: '天线 {{code}} 未启动',
    authentication_failed: '身份验证失败',
    field_required: '字段 {{label}} 为必填项',
    unable_to_connect_to_rfid_reader: '无法连接到 RFID 阅读器。请检查设备是否已开启。',
    items_in_error_found: '发现错误商品',
    item_not_in_inbound: '商品未入库',
    item_not_in_stock: '商品缺货',
    item_in_another_parcel: '商品在另一个包裹中',
    item_in_another_production_order: '商品在另一个生产订单中',
    connection: '连接错误',
    connection_details: '服务器无响应。请检查您的互联网连接或 VPN 配置是否正常。',
    field_invalid_default: '字段 {{field}} 的默认值"{{defaultValue}}”无效',
    field_invalid_default_from_endpoint: '找不到字段 {{field}} 的值',
    sorting_already_read: '序列号为 {{serial}} 的项目已在组 {{group}} 中读取',
    sorting_no_group: '项目不可排序',
    sorting_not_in_zone: '序列号为 {{serial}} 的项目不可排序。已在区域 {{zone}}',
    sorting_unknown: '标签 {{tag}} 无效',
    sorting_unexpected: '意外标签',
    no_item_configuration: '未找到商品配置',
    item_creation_error: '商品创建错误',
    cannot_find_production_order: '找不到生产订单',
    cannot_find_production_order_row: '找不到生产订单行',
    missing_operation_option: '缺少操作选项: {{error}}',
    item_session_list_create: '未创建的列表',
    item_session_list_create_session: '未创建的会话列表',
    item_session_list_confirm: '未确认的列表',
    item_session_list_confirm_session: '未确认的会话列表',
    form_validation: '验证表单',
    form_validation_message: '填写字段时出错',
    select_place_error: '无法保存原产地',
    self_user_data: '无法保存您的数据',
    encoding_no_tags: '未读取其他标签。操作已中止',
    only_virgin_tag: '仅检测到原始标签',
    tags_mismatch_error: '请一次读取一个标签',
    tags_errors: '标签错误',
    value_not_valid: '输入的值无效',
    write_tag: '写入标签时出现未知错误',
    WRONG_PRODUCTION_ORDER: '生产订单错误',
    WRONG_PLACE: '位置错误',
    PRODUCTION_ORDER_ROW_CREATION_ERROR: '生产订单行创建错误',
    force_tag_associated: '标签已关联。重新关联？',
    operation_confirm_error: '确认操作时出错',
    missing_mandatory_qc: '无质量控制。是否继续？',
    wrong_qc_status: '该产品已被声明为 KO。是否继续？',
    wrong_qc_size: '检查尺寸。是否继续？',
    wrong_qc_size_payload: '检查尺寸。编码尺寸: {{productSize}} - 物理尺寸: {{manualSize}}。是否继续？',
    wrong_qc_model: '检查型号。是否继续？',
    start_checklist: '取消启动清单',
    confirm_with_unexpected: '无法确认异常标签',
    confirm_with_overqty: '无法确认超量标签',
    rfid_reader_initialization: 'RFID 读取器初始化期间出现未知错误',
    remove_sap_item_error: '无法移除项目',
    no_asn_selected: '未选择 ASN',
    submit_asn: '提交 ASN 时出错',
    zbpNotFound: '您的系统上未找到 Zebra 浏览器打印代理。请确保其已安装并正在运行',
    no_printer_selected: '未选择打印机',
    zplTemplateNotDefined: 'ZPL 模板未定义。请在操作配置的‘zpl-template-code’属性中设置模板代码',
    no_print_template: '未找到打印模板',
    wrong_tag: '错误的标签',
    tag_error_or_not_authentic: '标签不真实或身份验证错误',
    authentic_timeout: '身份验证超时',
    tid_missing: '已读取标签的 TID 缺失',
    on_destination: '目的地 {{destination}}',
    item_not_sortable: '序列号为 {{serial}} 的商品不可排序',
    search_error: '搜索错误',
    no_parcel_found_by_identifier: '未找到具有此标识符的包裹',
    kill_tag_not_allowed: '无法删除与商品关联的标签。要销毁标签,请先解除与商品的关联。',
    kill_already_killed: '标签已删除',
    can_kill_only_tag_type: '您只能销毁 {{type}} 个标签',
    replace_tag_not_allowed: '您只能替换与商品关联的标签',
    kill_tag_not_success: '销毁标签失败',
    replace_tag_not_success: '替换标签失败',
    nfc_tag_not_expected: '此商品未指定 NFC 标签',
    venturing_quantity_reached: '此商品的通风量已达到',
    confirm_not_allowed_with_errors: '出现错误,不允许确认',
    close_not_allowed_with_errors: '出现错误,不允许关闭',
    generic: '发送反馈时发生错误',
    form_entry: '某些字段为必填项',
    invalid_tag_read: '读取的标签无效',
    read_one_tag_time: '每次仅读取一个标签',
    validation_failed_rewrite: '重写配置验证失败',
    uhf_tag_not_found: '未找到超高频标签',
    compute_tags_failed: '生成待写入标签失败',
    be_generic_error: '系统错误',
    be_generic_error_description: '系统发生一般错误。',
    identifier_production_order_not_found: '未找到生产订单',
    gs1code_invalid: 'GS1 代码无效',
    //cucinelli
    nfc_already_associated: 'NFC 已关联。解除关联并重复操作',
    too_many_valid_tag_read: '读取的有效标签过多',
    fields_required: '必填',
    exceeded_quantity: '数量超出',
    production_order_completed: '生产订单已完成',
    production_order_row_completed: '生产订单行已完成',
    replace_tag_not_allowed_for_this_tag: '无法替换此类标签',
    box_already_received: '盒子已收到。跳过阅读。'
  },
  messages: {
    no_operations_found: '未找到任何操作。请检查控制面板上的用户权限',
    not_allowed_operation: '您无权执行此操作。请检查您的配置',
    no_workstations_found: '未找到工作站',
    no_workstation_selected: '未选择工作站',
    are_you_sure_to_reset_daily_items: '您确定要重置每日物品吗？',
    bring_an_item_to_antenna: '将物品带到天线',
    press_start_to_read: '按下“开始”按钮\n开始读取 RFID 产品',
    reading_in_progress: '正在读取',
    waiting_for_product: '正在等待产品...',
    paste_comma_separeted_tags: '粘贴逗号分隔的标签,然后按回车键...',
    connection_workstation_progress: '正在连接到工作站...',
    operation_success: '操作已成功确认',
    outbound_success: '已成功确认出站',
    inbound_success: '入库确认成功',
    pack_success: '打包确认成功',
    transfer_to_zone_success: '转入区域确认成功',
    simple_item_list_success: '简单商品清单确认成功',
    list_empty: '清单为空',
    looks_like_anything_in_list: '您的清单中似乎没有任何商品',
    generic_success: '{{code}} 确认成功',
    generic_success_canceled: '{{code}} 取消成功',
    generic_error: '{{code}} 错误',
    fill_all_fields_and_search_an_item_configuration: '填写所有字段并搜索商品配置',
    encoding_success: '编码确认成功',
    encoding_success_none: '商品之前已关联',
    read_some_identifier_to_start_verification: '读取一些标识符以开始验证',
    warning_items_found: '发现警告项目',
    are_you_sure_you_want_to_confirm: '您确定要确认吗？',
    item_session_list_confirm: '列表确认成功',
    operation_in_progress: '操作正在进行中,请稍候...',
    sorting_error_zones: '原产地区域未评估,无法继续通风',
    connection_in_progress: '连接正在进行中...',
    checklist_there_are: '有',
    checklist_missings: '缺少项目',
    checklist_overqty: '超出项目',
    checklist_unexpecteds: '意外项目',
    checklist_confirm_mismatch_question: '您确定要确认吗？',
    force_update_content: '您确定要强制发送到SAP？',
    connection_to_station_in_progress: '正在连接站点',
    tag_killed: '标签已销毁',
    tag_replaced: '标签已替换',
    tag_deleted: '标签已删除',
    write_tag: '写入标签成功',
    not_ready: '未就绪',
    readyf: '就绪',
    nfcDecryption: 'NFC 解密中。请保持标签静止',
    parcel_success: '包裹已成功确认',
    sentry: {
      success: '感谢您的反馈！您的贡献有助于我们改进服务。'
    },
    confirm_force_shipment: '确认使用 PFAS 发货',
    input_rfid_barcodes: '请输入 RFID 条形码,以逗号或换行符分隔',
    //valentino
    are_you_sure_to_clear_reads: '您确定要清除读取吗？',
    are_you_sure_to_confirm: '您确定要确认吗？',
    inbound_conveyor_confirm_missing_message: '仍有 -缺失- 件商品需要确认,您确定要确认吗？',
    ///
    newVersionAvailable: '新版本可用',
    pageWillReload: '页面将在 30 秒后自动重新加载',
    update_available_description: '此页面有可用更新。请重新加载页面以应用更新。',
    deviceManagerUpdateTitle: '设备管理器更新',
    deviceManagerUpdateDescription: '设备管理器（集成 RFID 阅读器的软件）有新的更新可用。立即更新以确保最佳运行。',
    deviceManagerUpdating: '设备管理器更新正在进行中。请等待完成…',
    deviceManagerUpdateCompleted: '更新已成功完成',
    deviceManagerUpdateCompletedAndRequiresReboot: '更新已成功完成。请重新启动系统以应用更新。',
    exceeded_quantity_message: '生产订单行的数量已达到上限。请确保更改该行或生产订单。',
    empty_production_order: '生产订单中没有行',
    empty_production_order_search: '没有与执行的搜索相匹配的生产订单行',
    areYouSureYouWantToDelete: '您确定要删除吗？'
  },
  placeholder: {
    search_shipment_parcel: 'Search Shipment or Parcel',
    search_product_parcel: 'Search Product or Parcel'
  },
  confirm: {
    discrepancy_title: '包裹存在差异',
    discrepancy_message: '发现存在差异的商品。您确定要确认包裹吗？',
    confirm_delete_association: '您确定要删除此商品关联吗？',
    confirm_delete_operation_title: '删除 {{operation}}',
    confirm_delete_operation: '您要删除此操作吗？所有已读取的项目都将丢失。',
    confirm_delete_item_association: '您确定要删除此项目关联吗？',
    confirm_kill_tag: '您确定要终止 {{type}} 标签 {{tag}} 吗？',
    confirm_multiple_kill_tag: '您确定要终止所有标签吗？',
    confirm_disassociate_kill_tag: '您确定要解除关联并终止 {{type}} 标签 {{tag}} 吗？',
    confirm_disassociate_multiple_kill_tag: '您确定要解除关联并终止所有标签吗？',
    confirm_operation_title: '确认 {{operation}}',
    confirm_operation_text: '您是否要确认此操作？',
    confirm_operation_text_irreversible: '您是否要确认此操作？此操作无法撤消。',
    confirm_operation_text_partial_confirm: '正在向 JDE 发送读取信息。您确定要继续吗？',
    confirm_operation_text_partial_confirm_without_jde: '您确定要继续吗？',
    post_confirm_action_title: '继续',
    post_confirm_action_keep_input: '操作完成。执行其他操作吗？',
    post_confirm_action_change_input: '操作完成。执行其他操作吗？',
    confirm_close_asn_title: '关闭确认',
    confirm_close_asn_text: '部分包裹尚未收到。您确定要强制关闭此货件吗？',
    unpack: '包裹已打包。您是否要继续重新拆包和打包？',
    last_parcel_confirmerd: '已确认货件 {{code}} 的所有包裹。也关闭该货件吗？'
  },
  labels: {
    draft: '草稿',
    ready_to_send: '准备发送',
    send_await: '待处理',
    outbound_error: '出站错误',
    sent: '已发送',
    in_inbound: '入站中',
    receive_await: '待处理',
    ready_to_receive: '待接收',
    inbound_error: '入站错误',
    received: '已接收',
    in_transit: '运输中'
  },
  serverError: {
    //moncler
    WRONG_ITEM_SUPPLIER: '部分已读取商品无法由供应商接收。',
    QUANTITY_MISMATCH_ERROR: '输入的数量与检测到的数量不符。',
    ZONE_MISMATCH_ERROR: '输入的区域与检测到的区域不符。'
  },
  error_messages: {
    password_required: '密码字段为必填项',
    invalid_password: '密码无效',
    //moncler
    missing_workstation_place: '缺少工作站位置'
  },
  report_tbox: {
    umg: 'Umg',
    ddt_number: 'DDT N.',
    creation_date: '日期',
    capi_mdc: 'Capi MDC',
    qt_totale: '总数量',
    qt_accettata: '接受数量',
    qt_scartata: '拒绝数量',
    supplier: '供应商',
    notes: '备注'
  },
  custom: {
    countTBoxParcel: 'Parcel',
    countTBoxDDT: 'DDT',
    BARCODE_READ: 'Barcode Read',
    RFID_START_READING: 'Start reading',
    RFID_STOP_READING: 'Stop reading',
    RESULT_EVENT: 'Result event',
    TRACE: 'Trace',
    INFO: 'Info',
    WARNING: 'Warning',
    ERROR: 'Error',
    deleteSession: 'Delete Parcel',
    deleteSessionMessage: 'Are you sure you want to delete the parcel?',
    deleteList: 'Delete DDT',
    deleteListMessage: 'Are you sure you want to delete the ddt?',
    WAM: 'SKU',
    sap_warning: 'SAP warning',
    total_list: 'Total list',
    total_parcel: 'Total parcel',
    order_number: 'Order number',
    addon: 'Addon',
    componentType: 'Component Type',
    //cucinelli
    barcode: '条形码 BC',
    barcodeBCTrim: '条形码 BC 修剪',
    barcodeJDE: '条形码 JDE',
    barcodeROQ: '条形码 ROQ',
    barcodeROQTrim: '条形码 ROQ 修剪',
    class: '类别',
    department: '部门',
    dimensionSystem: '自定义类别',
    ean: 'EAN',
    eanIdPadre: '父 EAN',
    itemId: '商品 ID',
    stagioneROQ: 'ROQ 季节',
    subclass: '模型类型',
    subdepartment: '子部门',
    variantType: '类型',
    variantModel: '变体模型',
    cardCode: '卡片代码',
    label: '标签',
    rfidEnabled: 'RFID 启用',
    stato: '状态',
    ricondizionamentoFornitore: '翻新供应商',
    codiceShelf: '库存隔间',
    montante: '区域',
    ripiano: '箱体',
    scaffale: '货位',
    ASSOCIATED: '已关联',
    NOT_ASSOCIATED: '未关联',
    REPLACED_ASSOCIATION: '已替换',
    identifiers: '标识符',
    force_parcel: '强制包裹',
    force_parcel_message: '您确定要强制此包裹吗？',
    pesa_collo: '颈部重量',
    peso_kg: '重量（公斤）',
    wrong_packaging_code: '包装代码错误',
    packaging_confirmed_no_weight: '您正在确认一个没有重量的包裹，是否要是否继续？',
    attention: '注意',
    continue: '继续',
    model: 'Modello',
    sizeCode: '尺码代码',
    sizeDescription: '尺码描述',
    serial: '序列号',
    identifier: '序列号',
    product: '条形码 BC',
    shift: '班次',
    destination: '目的地',
    regDate: '日期',
    listPosition: '列表位置',
    list: '列表',
    customerName: '客户名称',
    regTime: '时间',
    event: '事件',
    customer: '客户',
    isCarryover: '结转',
    carryoverValue: '结转',
    madeIn: '产地',
    collectionCode: '系列',
    collectionDescription: '系列描述',
    collectionYear: '年份',
    fatherProductValue: '父产品',
    genderValue: '性别',
    genderValueDescription: '性别描述',
    line: '品牌线',
    lineDescription: '产品线描述',
    marchioDescription: 'Marchio描述',
    marchioValue: 'Marchio',
    merchandiseClassCode: '类别',
    merchandiseClassDescription: '类别描述',
    merchandiseSubclassCode: '子类别',
    merchandiseSubclassDescription: '子类别描述',
    modelPartColor: '模型部件颜色',
    modelPartColorSizeValue: '模型部件颜色尺码',
    isPermanent: '永久',
    permanentValue: '永久',
    isSeasonal: '季节性',
    seasonalValue: '季节性',
    sleeveTypeValue: '袖子类型',
    origin_location_mandatory_field_error: '需要原产地',
    transactionDate_mandatory_field_error: '需要交易日期',
    customerCode_mandatory_field_error: '需要客户代码',
    tipology_field_error: '需要类型',
    warehouseUsa_relabeling_mandatory_fields_error: '需要重新卷绕',
    //valentino
    sconosciuto: '未知',
    prodottoSconosciuto: '未知产品',
    reads_ok: '读取成功',
    tot_to_check: '待检查总数',
    //moncler
    confirm_force_received_text: '此批货物已确认。您要将其从列表中删除吗?',
    //louis vuitton
    tooManyTags: '标签过多',
    nfcDetectedPleaseUseProductControl: '检测到 NFC 标签。请使用产品控制功能。',
    GENERIC_ERROR: '一般错误 - 请通过 ContactIS 联系支持',
    ECERTIFICATE_WORKORDER_NOT_FOUND: '未在电子证书中找到工作订单',
    ITEM_IN_ANOTHER_PARCEL: '此商品已在其他包裹中申报',
    ECERTIFICATE_WORKORDER_CREATED_BOT_NOT_COMPLETED: '工作订单已在电子证书中创建，但尚未完成',
    INVALID_TIMESTAMP: '时间戳无效',
    INVALID_SERIAL: '序列号无效',
    INVALID_WORKORDER: '工作订单编号无效',
    INVALID_SKU: 'SKU 无效',
    INVALID_PARCEL_NUMBER: '包裹编号无效',
    SAP_UCS_NOT_CONFIRMED: 'UCS *{parcelCode} 在装配线末端未确认',
    SAP_REMOVABLE_SYNCHRO_NOT_PERFORMED: '可拆卸同步未执行',
    SAP_INCORRECT_OPERATION_STATUS: 'SAP ME 中 UCS *{parcelCode} 的操作状态不正确',
    SAP_COMPLETED_NOT_FOUND_IN_TNT: 'UCS 已在 SAP 中完成，但在 T&T 中不存在',
    SAP_UCS_CANNOT_BE_COMPLETED: 'UCS *{parcelCode} 无法在 SAP ME/MII 中完成',
    SAP_WORKORDER_CLOSED: '与 UCS *{parcelCode} 关联的工作单已在 SAP MII 中关闭',
    SAP_INTERNAL_ERROR: 'SAP MII 中出现技术错误',
    SAP_TIMEOUT_BUT_OK_AGGREGATION: '超时 -> 聚合正常',
    LVSP_PARCEL_NUMBER_ALREADY_AGGREGATED: '包裹编号已在 LVSP 中汇总',
    LVSP_SERIAL_ALREADY_AGGREGATED: '序列号已在之前的 LVSP 中汇总',
    LVSP_MISMATCH_EXPECTED_QUANTITY: 'LVSP 中扫描的数量与预期数量不匹配',
    LVSP_SKU_NOT_FOUND: 'LVSP 中的 SKU 未知',
    LVSP_SUPPLIER_NOT_FOUND: 'LVSP 中的供应商未知',
    TECHNICAL_ERROR: '技术问题 - 请通过 ContactIS 联系支持',
    ERROR_IN_PARCEL_ITEMS: '确认包裹时发生错误。请使用垃圾桶图标清空包裹，然后重新扫描所有商品',
    NFC_PRODUCT_NOT_ALLOWED: '该SKU需要NFC标签。请使用产品控制功能。',
    product_is_authentic: '产品为正品',
    not_sellable: '不可销售。请开具NeoContact工单（放入WDF存储桶）。',
    stock_product: '库存产品：保持产品可销售。客户退货：可以退货或换货，请保持产品可销售状态。',
    store_action: '商店操作',
    reprint: '重印',
    reprint_sent: '重印已发送',
    row: '行',
    longSKU: '长SKU',
    pairingDate: '生产日期',
    citesFlag: '引用',
    pairingSupplier: '供应商',
    batchNumber: '批次',
    status: '状态',
    chrono: '计时',
    logisticStatus: '产品状态',
    serialNumber: 'RFID序列号',
    returnCode: '退货代码',
    // others
    reference: '参考号',
    sender: '发送者',
    year: '年份',
    number: '号码',
    TAG_STATUS_CONFIRMED: '关联交易',
    halfpair: '半对'
  },
  imbustatrice: {
    and: ' 和 ',
    unkwon_tag: '未知标签',
    dynamic_tag: '{{role}} 标签',
    dynamic_tag_missing: '{{role}} 标签缺失',
    too_many_dynamic_tags: '{{role}} 标签过多',
    dynamic_tag_already_associated: '{{role}} 标签已关联',
    wrong_tag: '错误标签',
    missing_tag: '标签缺失'
  },
  identifier_error: {
    ALREADY_ASSOCIATED_TAG: '已关联',
    WRONG_QC_STATUS: '质量控制状态错误',
    WRONG_QC_SIZE: '质量控制大小错误',
    WRONG_QC_MODEL: '质量控制模型错误',
    MISSING_MANDATORY_QC: '缺少质量控制',
    MISSING_PRODUCT_INFO: '缺少产品信息',
    WRONG_TAG: '错误标签',
    UNKNOWN_TAG: '未知标签',
    WRONG_PRODUCT: '错误产品',
    MISSING_MANDATORY_TAG: '缺少必填标签',
    MISSING_OPTIONAL_TAG: '缺少可选标签',
    EXTRA_TAG: '额外标签',
    TAG_MISMATCH: '标签不匹配',
    PRODUCTIONORDERROW_MISMATCH: '生产订单行关联不匹配',
    MISSING_SYSTEM_TAG: '未知标签',
    UNEXPECTED_TAG: '意外标签',
    NOT_EXISTING_CERTILOGO_TAG: '系统中不存在 Certilogo 代码',
    KILLED_TAG: '标签已删除',
    MISSING_TAG: '缺失标签'
  },
  statuses: {
    RESTORE_VARIANT: '恢复类型',
    CONFIRM_ERROR: '确认错误'
  },
  userSettings: {
    title: '用户设置',
    autostopAntennaTimeout: '天线停止超时（毫秒）',
    autostartAntenna: '自动启动天线',
    autoConfirmParcel: '自动确认包裹',
    barcodeItemRead: '条形码商品读取',
    antennas: '天线设置',
    resetReadingsAfterOperation: '确认后复位速度',
    slow: '慢',
    medium: '中',
    fast: '快',
    printerCode: '打印机代码',
    enableOkSounds: 'OK 声音',
    enableKoSounds: 'KO 声音'
  },
  attributes: {
    material: '物料',
    workerCode: '工人代码',
    workerExternalCode: '工人外部代码',
    workerIdentifier: '工人标识符',
    workerDescription: '工人描述',
    workerType: '工人类型',
    orderCode: '订单代码',
    sapQualityControlStatus: 'SAP 质量控制状态',
    quantityOkWorker: '工人数量确认',
    quantityKoWorker: '工人数量确认',
    quantityOkRepair: '维修数量确认',
    quantityOkValdagno: '无确认数量确认',
    quantityOkFirstInbound: '首次入库数量确认',
    quantityOkRis: '风险数量',
    quantityKoValdagno: '无确认数量确认',
    quantitySecondValdagno: '第二选择数量',
    quantityOkLining: 'OK 衬里数量',
    quantityKoLining: 'KO 衬里数量'
  },
  title: {
    report_problem: '报告问题',
    delete_shipment_title: '删除确认'
  },
  subtitle: {
    report_problem: '描述您遇到的问题或提出改进建议',
    delete_shipment_message: '您确定要删除此批货物吗?'
  },
  label: {
    name: '姓名',
    email: '邮箱',
    description: '问题描述',
    close: '关闭',
    submit: '提交反馈'
  },
  success: {
    message: '感谢您的反馈!'
  },
  button: {
    submit: '提交反馈'
  }
}
